import * as React from 'react';
import { useColorScheme } from '@mui/joy/styles';
import GlobalStyles from '@mui/joy/GlobalStyles';
import CssBaseline from '@mui/joy/CssBaseline';
import Box from '@mui/joy/Box';
import Button from '@mui/joy/Button';
import Checkbox from '@mui/joy/Checkbox';
import Divider from '@mui/joy/Divider';
import FormControl from '@mui/joy/FormControl';
import FormLabel, { formLabelClasses } from '@mui/joy/FormLabel';
import IconButton, { IconButtonProps } from '@mui/joy/IconButton';
import Link from '@mui/joy/Link';
import Input from '@mui/joy/Input';
import Typography from '@mui/joy/Typography';
import Stack from '@mui/joy/Stack';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';
import BadgeRoundedIcon from '@mui/icons-material/BadgeRounded';
// import Image from '@mui/joy/image';
import { imageRatio } from '@utils/imageRatio';
import { Outlet } from 'react-router-dom';
import ColorSchemeToggle from '@components/ColorSchemeToggle';
import { Card } from '@mui/joy';
import { Copyright } from '@components/Copyright';
// import GoogleIcon from './GoogleIcon';
import { maestroLogo } from '@utils/assets';

export default function LoginLayout() {
  return (<>
    <GlobalStyles styles={theme => ({
      'body': {
        background: `linear-gradient(166deg, rgba(255,255,255,1) 70%, ${theme.palette.primary[500]} 70%)`,
      }
    })} />
    <Box sx={theme => ({
      padding: 4,
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      placeItems: 'center',
      // gap: 4,
      [theme.breakpoints.up('md')]: {
        placeContent: 'center',
      }
    })}>
      <img
        src={maestroLogo}
        alt="Maestro Logo"
        style={{width: '200px'}}
      />
      <Card variant='plain' sx={theme => ({
        boxShadow: theme.shadow.xl,
        width: '100%',
        marginTop: 4,

        [theme.breakpoints.up('md')]: {
          maxWidth: '500px',
          mx: 'auto',
        },
        // backdropFilter: 'blur(12px)',
        // backgroundColor: 'rgba(255 255 255 / 0.2)',
      })}>
        <Outlet/>
        {/* <Copyright/> */}
      </Card>
    </Box>
  </>);
}

/*
// https://mui.com/joy-ui/getting-started/templates/sign-in-side/
function LoginLayout({// export default function LoginLayout({
  children, // will be a page or nested layout
}: {
  children?: React.ReactNode
}) {
  return (
    <>
      <GlobalStyles
        styles={{
          ':root': {
            '--Collapsed-breakpoint': '769px', // form will stretch when viewport is below `769px`
            '--Cover-width': '50vw', // must be `vw` only
            '--Form-maxWidth': '50vw',
            '--Transition-duration': '0.4s', // set to `none` to disable transition
          },
        }}
      />
      <Box
        sx={(theme) => ({
          width:
            'clamp(100vw - var(--Cover-width), (var(--Collapsed-breakpoint) - 100vw) * 999, 100vw)',
          transition: 'width var(--Transition-duration)',
          transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
          position: 'relative',
          zIndex: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          backdropFilter: 'blur(12px)',
          backgroundColor: 'rgba(255 255 255 / 0.2)',
          [theme.getColorSchemeSelector('dark')]: {
            backgroundColor: 'rgba(19 19 24 / 0.4)',
          },
        })}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100dvh',
            width:
              'clamp(var(--Form-maxWidth), (var(--Collapsed-breakpoint) - 100vw) * 999, 100%)',
            maxWidth: '100%',
            px: 2,
          }}
        >
          <Box
            component="header"
            sx={{
              py: 3,
              display: 'flex',
              alignItems: 'left',
              justifyContent: 'space-between',
            }}
          >
            <Box sx={{ gap: 2, display: 'flex', alignItems: 'center' }}>
              <img
                src={maestroLogo}
                alt="Maestro Logo"
                // className="dark:invert"
                width={150}
                height={150 * imageRatio('logo')}
                // priority
              />
            </Box>
            <ColorSchemeToggle />
          </Box>
          <Box
            component="main"
            sx={{
              my: 'auto',
              py: 2,
              pb: 5,
              display: 'flex',
              flexDirection: 'column',
              gap: 2,
              width: 400,
              maxWidth: '100%',
              mx: 'auto',
              borderRadius: 'sm',
              '& form': {
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
              },
              [`& .${formLabelClasses.asterisk}`]: {
                visibility: 'hidden',
              },
            }}
          >
            <Outlet/>
          </Box>
          <Box component="footer" sx={{ py: 3 }}>
            <Typography level="body-xs" textAlign="center">
              © {new Date().getFullYear()} Maestro Community Manager
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box
        sx={(theme) => ({
          height: '100%',
          position: 'fixed',
          right: 0,
          top: 0,
          bottom: 0,
          left: 'clamp(0px, (100vw - var(--Collapsed-breakpoint)) * 999, 100vw - var(--Cover-width))',
          transition:
            'background-image var(--Transition-duration), left var(--Transition-duration) !important',
          transitionDelay: 'calc(var(--Transition-duration) + 0.1s)',
          backgroundColor: 'background.level1',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundImage:
            'url(https://images.unsplash.com/photo-1527181152855-fc03fc7949c8?auto=format&w=1000&dpr=2)',
          [theme.getColorSchemeSelector('dark')]: {
            backgroundImage:
              'url(https://images.unsplash.com/photo-1572072393749-3ca9c8ea0831?auto=format&w=1000&dpr=2)',
          },
        })}
      />
    </>
  );
}
*/
